import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgKojicAcidGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M17.265 24.05c8.106 0 15.637-5.971 18.695-15.048a.757.757 0 0 0-.465-.952.743.743 0 0 0-.94.471c-3.048 9.047-10.807 14.778-18.854 13.946-.742-.08-1.484-.22-2.216-.4V8.75A.752.752 0 0 0 12.742 8a.752.752 0 0 0-.742.751V39.25c0 .41.336.751.742.751.406 0 .742-.34.742-.751v-7.605h9.61l11.194 8.216c.129.1.287.14.435.14.228 0 .456-.11.604-.31a.76.76 0 0 0-.168-1.053L15.068 23.89c.158.02.317.05.485.07.564.06 1.138.09 1.712.09Zm3.79 6.091h-7.57v-5.56l7.57 5.56Z",
    fill: "currentColor"
  }));
}

export { SvgKojicAcidGlyphSecondary as default };
